/* eslint-disable no-nested-ternary */
export function generateXml(create, values, vehicle) {
  let salutation = values?.salutation?.displayValue ?? values?.salutation;
  salutation = salutation === 'Frau' ? 'MS' : 'MR';

  const phone = values?.phone?.displayValue ?? values?.phone;
  const email = values?.email?.displayValue ?? values?.email;

  const givenName = values?.first_name?.displayValue ?? values?.first_name;
  const familyName = values?.last_name?.displayValue ?? values?.last_name;
  const fullName = `${givenName} ${familyName}`;

  const root = create({ version: '1.0', encoding: 'UTF-8' })
    .ele('dealerdeskLead');

  const general = root.ele('generalInformation');

  general.ele('type').txt('OPPORTUNITY');
  general.ele('subject').txt('Individuelle Anfrage');
  general.ele('channel').txt('WEBSITE');
  // general.ele('caseType').txt('LEGAL_INSPECTION_APPOINTMENT');
  // general.ele('sourceId');
  // general.ele('sentiment').txt('10');

  general.ele('urgency').txt('NORMAL');
  // general.ele('appointmentTime');
  // general.ele('preferredContactMethod');
  // general.ele('preferredContactDetails');
  // general.ele('earliestContactTime');
  // general.ele('latestContactTime');
  // general.ele('externalReference');
  // general.ele('escalationGroupId');
  // general.ele('opportunityTeamId');
  // general.ele('individualReceiverUserId');

  const contact = root.ele('contact');
  contact.ele('status').txt('PROSPECT');
  contact.ele('type').txt('PRIVATE');

  if (salutation) {
    contact.ele('salutation').txt(salutation);
  }
  // contact.ele('knownSince');
  // contact.ele('dateOfBirth');
  // contact.ele('companyName');
  // contact.ele('department');
  // contact.ele('position');

  if (fullName) {
    contact.ele('fullName').txt(fullName);
  }

  // contact.ele('namePrefix');

  if (givenName) {
    contact.ele('givenName').txt(givenName);
  }
  if (familyName) {
    contact.ele('familyName').txt(familyName);
  }

  // contact.ele('address1');
  // contact.ele('address2');
  // contact.ele('zip');
  // contact.ele('city');
  // contact.ele('state');
  // contact.ele('country');

  if (phone) {
    contact.ele('phone').txt(phone);
  }
  if (email) {
    contact.ele('email').txt(email);
  }
  // contact.ele('externalReference');

  const requestedVehicle = root.ele('requestedVehicle');
  if (vehicle?.attributes.vehicleId) {
    requestedVehicle.ele('internalId').txt(vehicle?.attributes.vehicleId);
  }
  requestedVehicle.ele('link').txt(window.location.href);
  requestedVehicle.ele('vehicleClass').txt('CAR');

  if (vehicle?.attributes.brand) {
    requestedVehicle.ele('make').txt(vehicle.attributes.brand);
  }
  if (vehicle?.attributes.baselineModel) {
    requestedVehicle.ele('model').txt(vehicle.attributes.baselineModel);
  }
  if (vehicle?.attributes.model) {
    requestedVehicle.ele('modelDescription').txt(vehicle.attributes.model);
  }
  if (vehicle?.attributes.vehicleIdentificationNumber) {
    requestedVehicle.ele('vin').txt(vehicle.attributes.vehicleIdentificationNumber);
  }
  if (vehicle?.attributes.isNewCar !== undefined) {
    requestedVehicle.ele('usageType').txt(vehicle.attributes.isNewCar ? 'NEW' : 'USED');
  }
  if (vehicle?.attributes.mileage != null) {
    requestedVehicle.ele('mileage').txt(vehicle.attributes.mileage);
  }
  if (vehicle?.attributes.price != null) {
    requestedVehicle.ele('price').txt(vehicle.attributes.price);
  }
  if (vehicle?.attributes.initialRegistrationDate) {
    requestedVehicle.ele('firstRegistration').txt(vehicle.attributes.initialRegistrationDate);
  }
  if (FUEL_TYPE[vehicle?.attributes.fuelType]) {
    requestedVehicle.ele('fuel').txt(FUEL_TYPE[vehicle.attributes.fuelType]);
  }
  if (vehicle?.attributes.power != null) {
    requestedVehicle.ele('power').txt(vehicle.attributes.power);
  }
  // requestedVehicle.ele('exteriorColor');
  if (vehicle?.attributes.ccm != null) {
    requestedVehicle.ele('cubicCapacity').txt(vehicle.attributes.ccm);
  }
  // requestedVehicle.ele('preOffer');

  const acquisition = root.ele('acquisition');
  // acquisition.ele('tradeInRequested');
  // acquisition.ele('registrationRequested');
  // acquisition.ele('insuranceRequested');
  // acquisition.ele('deliveryRequested');

  if (values.requestTestDrive !== undefined) {
    acquisition.ele('testdriveRequested').txt(values.requestTestDrive ? '1' : '0');
  }
  // acquisition.ele('preferredTimeOfTestdrive');
  // acquisition.ele('counterOffer');
  // acquisition.ele('dealName');
  // acquisition.ele('acquisitionType');
  // acquisition.ele('bank');
  // acquisition.ele('paybackPeriodMonths');
  // acquisition.ele('totalMileage');
  // acquisition.ele('firstInstallment');
  // acquisition.ele('monthlyInstallment');
  // acquisition.ele('finalInstallment');

  const link = root.ele('link');
  link.ele('url').txt(window.location.href);
  link.ele('description').txt('Link zur Website');
  link.ele('key').txt('csb-schimmel-automobile');

  return root.end({ prettyPrint: false });
}

export const FUEL_TYPE = {
  other: 'OTHER',
  gasoline: 'PETROL',
  diesel: 'DIESEL',
  lpg: 'LPG',
  naturalGas: 'CNG',
  electric: 'ELECTRICITY',
  hybrid: 'HYBRID',
  hydrogen: 'HYDROGENIUM',
  ethanol: 'ETHANOL',
  hybridDiesel: 'HYBRID_DIESEL',
};
